import * as React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import BulkActionsDropdown from "components/common/EntityDataTable/BulkActionsDropdown";
import StringUtils from "util/StringUtils";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import useSelectedEntities from "components/common/EntityDataTable/hooks/useSelectedEntities";
import { DeleteMenuItem } from "components/bootstrap";
const VIEWS_BULK_DELETE_API_ROUTE = "/views/bulk_delete";
const BulkActions = () => {
  const queryClient = useQueryClient();
  const { selectedEntities, setSelectedEntities } = useSelectedEntities();
  const selectedItemsAmount = selectedEntities == null ? void 0 : selectedEntities.length;
  const descriptor = StringUtils.pluralize(selectedItemsAmount, "dashboard", "dashboards");
  const onDelete = useCallback(() => {
    if (window.confirm(`Do you really want to remove ${selectedItemsAmount} ${descriptor}?`)) {
      fetch("POST", qualifyUrl(VIEWS_BULK_DELETE_API_ROUTE), { entity_ids: selectedEntities }).then(({ failures }) => {
        if (failures == null ? void 0 : failures.length) {
          const notDeletedDashboardIds = failures.map(({ entity_id }) => entity_id);
          setSelectedEntities(notDeletedDashboardIds);
          UserNotification.error(
            `${notDeletedDashboardIds.length} out of ${selectedItemsAmount} selected ${descriptor} could not be deleted.`
          );
        } else {
          setSelectedEntities([]);
          UserNotification.success(
            `${selectedItemsAmount} ${descriptor} ${StringUtils.pluralize(selectedItemsAmount, "was", "were")} deleted successfully.`,
            "Success"
          );
        }
      }).catch((error) => {
        UserNotification.error(`An error occurred while deleting dashboards. ${error}`);
      }).finally(() => {
        queryClient.invalidateQueries({
          queryKey: ["dashboards", "overview"]
        });
      });
    }
  }, [descriptor, queryClient, selectedItemsAmount, selectedEntities, setSelectedEntities]);
  return /* @__PURE__ */ React.createElement(BulkActionsDropdown, null, /* @__PURE__ */ React.createElement(DeleteMenuItem, { onSelect: onDelete }));
};
export default BulkActions;
